import React from 'react';
import CardUI from '../../../widgets/layout/CardUI';
import { Link } from 'react-router-dom';
import './AccountSummaryDialog.css';

const AccountSummaryDialog = ({ isOpen, onClose, summaryData }) => {
  if (!isOpen || !summaryData) return null;

  const { accountName, loanSummaries, accountSummary } = summaryData;

  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return 'N/A';
    return `₹ ${parseFloat(amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const renderLrnLink = (lrn, loanId) => {
    if (loanId) {
      return <Link to={`/su/loans/${loanId}/repayments/v2`}>{lrn}</Link>;
    }
    return lrn;
  };

  return (
    <div className="modal_overlay">
      <div className="modal_container">
        <div className="modal_header">
          <h2 className="modal_title">{`Account Summary: ${accountName}`}</h2>
          <button className="modal_close_button" onClick={onClose}>×</button>
        </div>
        
        <div className="modal_content">
          <div className="account_summary_content">
            <CardUI className="summary_card">
              <div>
                <h3 className="section_title">Account Level Summary</h3>
                <div className="account_summary_box">
                  <div className="summary_item">
                    <div className="summary_label">Total Due</div>
                    <div className="summary_value">{formatCurrency(accountSummary.totalDue)}</div>
                  </div>
                  <div className="summary_item">
                    <div className="summary_label">Total Received</div>
                    <div className="summary_value">{formatCurrency(accountSummary.totalReceived)}</div>
                  </div>
                  <div className="summary_item">
                    <div className="summary_label">Total Pending</div>
                    <div className="summary_value">{formatCurrency(accountSummary.totalPending)}</div>
                  </div>
                  <div className="summary_item">
                    <div className="summary_label">Overdue Interest</div>
                    <div className="summary_value">{formatCurrency(accountSummary.totalOverdueInterest)}</div>
                  </div>
                </div>
              </div>
            </CardUI>

            <CardUI className="summary_card">
              <div>
                <h3 className="section_title">Loan Level Summaries</h3>
                {loanSummaries && loanSummaries.length > 0 ? (
                  <table className="summary_table table_cr table">
                    <thead className="table_head g_sticky_header">
                      <tr>
                        <th className="table_header">LRN</th>
                        <th className="table_header">Total Due</th>
                        <th className="table_header">Total Received</th>
                        <th className="table_header">Total Pending</th>
                        <th className="table_header">Overdue Interest</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loanSummaries.map((loan, index) => (
                        <tr 
                          key={`loan-summary-${loan.lrn}-${index}`}
                          className={index % 2 === 0 ? "table_row_even" : "table_row_odd"}
                        >
                          <td className="table_cell">{renderLrnLink(loan.lrn, loan.loanId)}</td>
                          <td className="table_cell">{formatCurrency(loan.totalDue)}</td>
                          <td className="table_cell">{formatCurrency(loan.totalReceived)}</td>
                          <td className="table_cell">{formatCurrency(loan.totalPending)}</td>
                          <td className="table_cell">{formatCurrency(loan.totalOverdueInterest)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no_data_message">No loan data available</div>
                )}
              </div>
            </CardUI>
          </div>
        </div>

        <div className="modal_footer">
          <button 
            onClick={onClose} 
            className="close_btn btn btn_secondary"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountSummaryDialog;